export default "__VITE_ASSET__X4ZbJCSw__"